import gql from 'graphql-tag'

export const deleteCompany = gql`
  mutation deleteCompany($id: ID! ) {
    deleteCompany(id: $id) {
      status
    }
  }
`
